import React, { useState } from 'react';
import { ProductPageModel } from '../../Types/ProductPageModel';
import QuantityInput from '../QuantityInput/QuantityInput';
import BuyButton from '../BuyButton/BuyButton';
import clsx from 'clsx';
import BuySampleButton from '../BuyButton/BuySampleButton';
import { StockStatusLevel } from '../../constants';

const ProductPageBuySection = ({
  product,
}: {
  product: ProductPageModel;
}) => {
  const [buyQuantity, setBuyQuantity] = useState(1);

  return product.stockStatus?.level !== StockStatusLevel.Inactive ? (
    <div className="mb-3 flex flex-col gap-3">
      {!!product.productItem.price?.price &&
        !!product.stockStatus?.inStock &&
        !product.disableBuyOption && (
          <div className="flex flex-row gap-3">
            <QuantityInput
              className="min-w-[112px]"
              onChange={setBuyQuantity}
              wrapperClassName="col-span-1 [&.quantity-input_div]:h-full"
              showButtons={true}
              disabled={!product.productItem.price?.price}
              mediumSize={true}
            />
            <BuyButton
              articleNumber={product.productItem.id}
              quantity={buyQuantity}
              className={clsx(
                !product.productItem.price?.price && 'opacity-80',
                'col-span-3'
              )}
              disabled={!product.productItem.price?.price}
            />
          </div>
        )}
      {product.stockStatus?.level !== StockStatusLevel.Inactive &&
        !product.disableBuyOption &&
        product.productItem.samples?.map((sample) => (
          <BuySampleButton
            {...sample}
            className="col-span-4 border border-solid border-gray-700"
            key={`sample-${sample.articleNumber}`}
          />
        ))}
    </div>
  ) : null;
};

export default ProductPageBuySection;
